import { screenDeltaToWorld } from './transform';
import type { ViewportState } from './types';

/**
 * Pans by a screen-pixel delta — the drawing follows the pointer, so dragging
 * right moves the content right (the centre moves left in world space).
 *
 * The delta is un-rotated first, so panning stays direct in a quarter-turned view
 * rather than sliding off at right angles to the drag.
 */
export const panByScreenDelta = (
  viewport: ViewportState,
  deltaX: number,
  deltaY: number,
): ViewportState => {
  const [worldDeltaX, worldDeltaY] = screenDeltaToWorld(
    deltaX,
    deltaY,
    viewport,
  );
  return {
    ...viewport,
    center: [
      viewport.center[0] - worldDeltaX,
      viewport.center[1] - worldDeltaY,
    ],
  };
};
